import { render } from "./insureBetList.vue?vue&type=template&id=774252ec&scoped=true"
import script from "./insureBetList.vue?vue&type=script&lang=js"
export * from "./insureBetList.vue?vue&type=script&lang=js"

import "./insureBetList.vue?vue&type=style&index=0&id=774252ec&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-774252ec"]])

export default __exports__